import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



@Component({
  selector: 'app-rename',
  templateUrl: './rename.component.html',
  styleUrls: ['./rename.component.scss']
})
export class RenameComponent implements OnInit {

  renameForm: UntypedFormGroup;

  constructor(
    public dialog: MatDialogRef<RenameComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { depName: string; path: string; vmNodeName: string; name: string },
  ) { }

  ngOnInit(): void {
    this.renameForm = new UntypedFormGroup({
      fileName: new UntypedFormControl(this.data.name, [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+\.[a-zA-Z0-9]{1,15}$")])
    })
  }

  onSubmit(form) {
    if (form.status == 'INVALID') {
      form.controls.fileName.touched = true;
    } else {
      this.dialog.close(form.value.fileName)
    }
  }

  onClose() {
    this.dialog.close(false)
  }

}
